import * as Yup from 'yup';

export const ValidationSchema = Yup.object().shape({
  email: Yup.string()
    .nullable()
    .email('Email address is incorrect')
    .matches(/([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+/, 'Email address is incorrect')
    .required('This field is required')
    .max(100, 'You have exceeded the maximum number of 100 characters'),
});
